export const createArray = (numberForArray: number) =>
  Array.from({ length: numberForArray }, (_, index) => index)
